<template>
  <div>
    <div class="cartsave-list-items">
      <TransitionGroup name="cartsave-list" tag="div">
        <div :class="{'inactiveCartSaveItem':item.data.filter.isSalableAndActive !== true}"
             class="cart-item bg-white white-bg p-3 align-items-center col-12 border-bottom"
             v-for="(item) in cart.items"
             :key="item.uId">
          <template v-if="cartMode==='slideIn'">
              <div class="row">
                <div class="col-2">
                  <div class="bg-white-shadow">
                    <img v-if="item.data.images.variation.length > 0 && item.data.images.variation[0].urlPreview" :src="item.data.images.variation[0].urlPreview" class="img-fluid">
                    <img v-else-if="item.data.images.variation.length > 0 &&  item.data.images.variation[0].urlSecondPreview" :src="item.data.images.variation[0].urlSecondPreview" class="img-fluid">
                    <img v-else-if="item.data.images.all[0].urlPreview" class="img-fluid" :src="item.data.images.all[0].urlPreview">
                    <img v-else :src="item.data.images.all[0].urlMiddle" class="img-fluid">
                  </div>
                </div>
                <div class="col-10">
                  <template v-if="item.data.variation.isActive == true">
                    <a aria-label="link to item" class="font-weight-bold" v-html="item.data.texts.name1" :href="item.data | itemURL(urlWithVariationId)"></a>
                  </template>
                  <template v-else>
                    <span class="font-weight-bold" v-html="item.data.texts.name1"></span>
                  </template>
                  <template v-if="item.data.variation.isActive == true">
                    <p class="text-muted small"  v-html="item.data.variation.availability.names.name"></p>
                  </template>
                  <template v-else>
                    <p class="text-muted small" > {{ $translate("CartSave::Template.itemNotAvailable") }}</p>
                  </template>
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <button
                      :disabled="item.data.filter.isSalableAndActive !== true ||
                      item.cartloading ||
                      (item.variations && item.variations.length > 0 && item.id == 0)"
                      @click="addToBasket(item,cart)"
                      class="btn btn-primary btn-min-width-small mr-2">
                    <template v-if="item.cartloading">
                      <i class="fa fa-circle-o-notch fa-spin"></i>
                    </template>
                    <template v-else>
                      <i class="fa fa-shopping-cart"></i>
                    </template>
                  </button>
                </div>
                <div class="col-10">
                  <template v-if="cart.editMode">
                    <div class="d-flex">
                      <button :disabled="item.data.filter.isSalableAndActive !== true"  class="btn btn-primary YbbQuantityButtons big"  @click="updateQuantity(item,cart,'-')">
                        -
                      </button>
                      <input :disabled="item.data.filter.isSalableAndActive !== true" type="text" inputmode="numeric" class="text-center qty-input border-none grey-bg flex-fill" @change="updateQuantity(item,cart)" v-model.number="item.quantity"/>
                      <button :disabled="item.data.filter.isSalableAndActive !== true" class="btn btn-primary YbbQuantityButtons big" @click="updateQuantity(item,cart,'+')">
                        +
                      </button>
                    </div>
                  </template>
                  <template v-else>
                    <div class="d-flex">
                      <div class="w-50">{{ $translate("CartSave::Template.cartItemQuantity") }}</div>
                      <div class="w-50 text-right">{{ item.quantity }} x</div>
                    </div>
                  </template>
                  <template v-if="item.price">
                    <div class="d-flex">
                      <div class="w-50">{{  $translate("CartSave::Template.cartItemPriceTotal") }}</div>
                      <div class="w-50 text-right">{{ item.quantity * item.price.value | currency }}</div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="d-flex">
                      <div class="w-50">{{  $translate("CartSave::Template.cartItemPriceTotal") }}</div>
                      <div class="w-50 text-right">{{ item.quantity * item.data.prices.default.price.value | currency }}</div>
                    </div>
                  </template>
                  <div class="d-flex">
                    <div class="w-50">{{  $translate("CartSave::Template.cartItemItemId") }}</div>
                    <div class="w-50 text-right">{{ item.itemId }}</div>
                  </div>
                  <template v-if="(item.variations && item.selectedVariation===null && item.variations.length > 0 && item.id == 0) || cart.editMode">
                    <select @change="changeSelect(item,$event)">
                      <option :value="0" selected="selected" :disabled="true" v-if="item.id == 0">
                        {{  $translate("CartSave::Template.cartItemChoose") }}
                      </option>
                      <option v-for="variation in item.variations" :value="variation.id" :disabled="variation.stock <= 0" :selected="item.id == variation.id">
                        <template v-for="attr in variation.attributes">
                           {{ attr.attribute.names.name }} -
                          {{ attr.value.names.name }}
                          <template v-if="variation.stock <= 0">
                            - Ausverkauft
                          </template>
                        </template>
                      </option>
                    </select>
                  </template>
                  <template v-else>
                    <template v-if="item.attributes">
                      <div class="d-flex" v-if="item.attributes.length > 0" v-for="attribute in item.attributes">
                        <div class="w-50">
                          <span class="font-weight-bold" v-html="attribute.attribute.names.name"></span>:
                        </div>
                        <div class="w-50 text-right">
                          <span v-html="attribute.value.names.name"></span>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="d-flex" v-if="item.data.attributes.length > 0" v-for="attribute in item.data.attributes">
                        <div class="w-50">
                          <span class="font-weight-bold" v-html="attribute.attribute.names.name"></span>:
                        </div>
                        <div class="w-50 text-right">
                          <span v-html="attribute.value.names.name"></span>
                        </div>
                      </div>
                    </template>
                  </template>
                  <template v-if="cart.editMode">
                    <div class="d-block">
                      <button class="btn btn-danger btn-block" @click="deleteItem(cart.id,item.itemId,item.id)">
                        <i class="fa fa-trash-o"></i>
                         {{ $translate("CartSave::Template.cartDeleteItem") }}
                      </button>
                    </div>
                  </template>
                </div>
              </div>
          </template>
          <template v-else>
            <div class="row">
              <div class="col-lg-6">
                <div class="row align-items-top">
                  <div class="col-lg-4">
                    <div class="bg-white-shadow">
                      <img v-if="item.data.images.variation.length > 0 && item.data.images.variation[0].urlPreview" :src="item.data.images.variation[0].urlPreview" class="img-fluid">
                      <img v-else-if="item.data.images.variation.length > 0 &&  item.data.images.variation[0].urlSecondPreview" :src="item.data.images.variation[0].urlSecondPreview" class="img-fluid">
                      <img v-else-if="item.data.images.all[0].urlPreview" class="img-fluid" :src="item.data.images.all[0].urlPreview">
                      <img v-else :src="item.data.images.all[0].urlMiddle" class="img-fluid">
                    </div>
                  </div>
                  <div class="col-lg-8" >
                    <template v-if="item.data.variation.isActive == true">
                      <a class="font-weight-bold" v-html="item.data.texts.name1" :href="item.data | itemURL(urlWithVariationId)" aria-label="link to item"></a>
                    </template>
                    <template v-else>
                      <span class="font-weight-bold" v-html="item.data.texts.name1"></span>
                    </template>
                    <template v-if="item.data.variation.isActive == true">
                      <p class="text-muted small"  v-html="item.data.variation.availability.names.name"></p>
                    </template>
                    <template v-else>
                      <p class="text-muted small" > {{ $translate("CartSave::Template.itemNotAvailable") }}</p>
                    </template>
                    <template v-if="!isPublic">
                      <template v-if="item.variations && item.selectedVariation===null && item.variations.length > 0">
                        <select @change="changeSelect(item,$event)">
                          <option v-for="variation in item.variations" :value="variation.id" :disabled="variation.stock <= 0">
                            <template v-for="attr in variation.attributes">
                              {{ attr.attribute.names.name }} -
                              {{ attr.value.names.name }}
                              <template v-if="variation.stock <= 0">
                                - Ausverkauft
                              </template>
                            </template>
                          </option>
                        </select>
                      </template>
                      <template v-else>
                        <ul v-if="item.attributes.length > 0" class="list-unstyled list-inline">
                          <li v-for="attribut in item.attributes">
                            <span class="font-weight-bold" v-html="attribut.attribute.names.name"></span>: <span v-html="attribut.value.names.name"></span>
                          </li>
                        </ul>
                      </template>
                    </template>
                    <template v-else>
                      <ul v-if="item.data.attributes.length > 0" class="list-unstyled list-inline">
                        <li v-for="attribut in item.data.attributes">
                          <span class="font-weight-bold" v-html="attribut.attribute.names.name"></span>: <span v-html="attribut.value.names.name"></span>
                        </li>
                      </ul>
                    </template>
                  </div>
                </div>
              </div>
              <div class="col-lg-2 col-4">
                <div class="flex-column">
                  <div>
                    <b>
                      {{ $translate("CartSave::Template.cartItemPrice") }}
                    </b>
                  </div>
                  <template v-if="item.price">
                    <div v-html="item.prices.default.price.formatted"></div>
                  </template>
                  <template v-else>
                    <div v-html="item.data.prices.default.price.formatted"></div>
                  </template>
                </div>
              </div>
              <template v-if="editable || isPublic">
                <!-- menge -->
                <div class="col-lg-2 col-4">
                  <div class="qty-box d-flex ml-0">
                    <input :disabled="item.data.filter.isSalableAndActive !== true" type="text" inputmode="numeric" class="text-center qty-input border-right" @change="updateQuantity(item,cart)" v-model.number="item.quantity"/>
                    <div class="cartSaveQuantity">
                      <button :disabled="item.data.filter.isSalableAndActive !== true" class="btn YbbQuantityButtons" @click="updateQuantity(item,cart,'+')">
                        +
                      </button>
                      <button :disabled="item.data.filter.isSalableAndActive !== true"  class="btn YbbQuantityButtons"  @click="updateQuantity(item,cart,'-')">
                        -
                      </button>
                    </div>
                  </div>
                </div>
                <!-- preis total -->
                <div class="col-lg-2 col-4">
                  <div class="btn-block-bg d-flex justify-content-end">
                    <div class="btn-group" role="group" aria-label="Basic example">
                      <button
                          :disabled="item.data.filter.isSalableAndActive !== true ||
                          item.cartloading ||
                          (item.variations && item.variations.length > 0 && item.id == 0)"
                          @click="addToBasket(item,cart)"
                          class="btn btn-primary btn-min-width-small mr-2">
                        <template v-if="item.cartloading">
                          <i class="fa fa-circle-o-notch fa-spin"></i>
                        </template>
                        <template v-else>
                          <i class="fa fa-shopping-cart"></i>
                        </template>
                      </button>
                      <button @click="deleteItem(cart.id,item.id)" class="btn btn-danger btn-min-width-small">
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <!-- menge -->
                <div class="col-lg-2 col-4">
                  <div class="flex-column">
                    <div>
                      <b>
                        {{  $translate("CartSave::Template.cartItemQuantity") }}
                      </b>
                    </div>
                    <div>
                      {{ item.quantity }} x
                    </div>
                  </div>
                </div>
                <!-- preis total -->
                <div class="col-lg-2 col-4">
                  <div>
                    <b>
                      {{  $translate("CartSave::Template.cartItemPriceTotal") }}
                    </b>
                  </div>
                  <div>
                    {{ item.quantity * item.data.prices.default.price.value | currency }}
                  </div>
                </div>
              </template>
            </div>
          </template>
        </div>
      </TransitionGroup>
    </div>
  </div>
</template>

<script>

export default
{
  name: "CsListItems",
  props:
  {
    deleteItemsFromList:
    {
      type      : String,
      default   : "false"
    },
    editable:
    {
      type      : Boolean,
      default   : false
    },
    cart:
    {
      type      : Object,
      default   : function () { return {} }
    },
    isPublic:
    {
      type      : Boolean,
      default   : false
    },
    cartMode:
    {
      type      : String,
      default   : ""
    }
  },
  methods:
  {
    formatNumberToQuantity(number)
    {
      if(Number.isInteger(number))
      {
        return number;
      }
      else
      {
        return number.toFixed(1)
      }

    },
    changeSelect(item,event)
    {
      let selectedVar = parseInt(event.target.value);
      let selectedAttr = '';
      let selectedFilter = '';
      let selectedPrice = '';
      for(let i = 0; i < item.variations.length; i++)
      {
        if(parseInt(item.variations[i].id) === parseInt(selectedVar))
        {
          selectedAttr    = item.variations[i].attributes;
          selectedFilter  = item.variations[i].filter;
          selectedPrice   = item.variations[i].price;
        }
      }
      if(selectedAttr !== '')
      {
        item.data.attributes           = selectedAttr;
        item.attributes                = selectedAttr;
        item.data.filter               = selectedFilter;
        item.data.prices.default.price = selectedPrice;
        item.price                     = selectedPrice;
      }
      item.selectedVariation = parseInt(event.target.value);
      item.id                = item.selectedVariation
      for(let i2 = 0; i2 < this.cart.cart_variations.length; i2++)
      {
        if(parseInt(item.itemId) === parseInt(this.cart.cart_variations[i2].itemId))
        {
          this.cart.cart_variations[i2].id = item.id
          this.cart.cart_variations[i2].itemId = item.itemId
        }
      }
      this.$store.dispatch('updateCart',this.cart)
    },
    deleteItem(cartid,itemid,id)
    {
      if(!this.isPublic)
      {
        this.$store.dispatch('removeItemFromList', {"cartid": cartid, "itemid": itemid, "id": id});
      }
      else
      {
        for(let i = 0; i < this.cart.items.length; i++)
        {
          if((parseInt(this.cart.items[i].itemId) === parseInt(itemid)) && (parseInt(this.cart.items[i].id) === parseInt(id)))
          {
            this.cart.items.splice(i,1)
          }
        }
      }
    },
    updateQuantity(item,cart,operator = null)
    {
      let minQuantity = 0;
      if(item.data.variation.intervalOrderQuantity > 0)
      {
        minQuantity = item.data.variation.intervalOrderQuantity;
      }
      else
      {
        minQuantity = 1;
      }

      if (operator == null)
      {
        if (item.quantity >= minQuantity)
        {
          if(!this.isPublic)
          {
            return this.$store.dispatch('updateCart',cart)
          }
        }
        else
        {
          item.quantity = parseFloat(this.formatNumberToQuantity(minQuantity));
          if(!this.isPublic)
          {
            return this.$store.dispatch('updateCart', cart)
          }
        }
      }
      else
      {
        if (operator === '+')
        {
          item.quantity = (parseFloat(item.quantity) + parseFloat(this.formatNumberToQuantity(minQuantity)))
          if(!this.isPublic)
          {
            return this.$store.dispatch('updateCart', cart)
          }
        }
        else
        {
          let newQuantity = (parseFloat(item.quantity) - parseFloat(this.formatNumberToQuantity(minQuantity)));
          if(newQuantity >= minQuantity)
          {
            item.quantity = newQuantity;
          }
          else
          {
            item.quantity = this.formatNumberToQuantity(minQuantity);
          }
          if(!this.isPublic)
          {
            return this.$store.dispatch('updateCart', cart)
          }
        }
      }
    },
    addToBasket(item = {},cart)
    {
      let _self = this;
      let data  = { "items":[] };
      if(Object.keys(item).length > 0)
      {
        item.cartloading = true;
        data.items.push({"variationId":item.id,"quantity":item.quantity,"name":item.data.texts.name1});
      }
      else
      {
        for(let i = 0; i < cart.items.length; i++)
        {
          _self.cart.waiting = true;
          if(cart.deleteBasketFirst)
          {
            data.deleteBasketFirst = true;
          }
          if(_self.cart.items[i].data.filter.isSalableAndActive === true)
          {
            data.items.push({
              "variationId" : _self.cart.items[i].id,
              "quantity"    : _self.cart.items[i].quantity,
              "name"        : _self.cart.items[i].data.texts.name1
            });
          }
        }
      }
      $.ajax({
        type: 'POST',
        url: '/rest/cartsave/basket/addToBasket/',
        data: data,
        success: function (response)
        {
          (Object.keys(item).length == 0) ? _self.cart.waiting = false : item.cartloading = false;
          for( let i = 0; i < response.length; i++)
          {
            _self.cart.deleteBasketFirst = false;
            if(response[i].error)
            {
              if(response[i].error.placeholder && response[i].error.placeholder.stock)
              {
                CeresNotification.error(ceresTranslate("CartSave::Template.notesNichtgenugbestand",
                {
                  variationName: response[i].error.variationName,
                  stock: response[i].error.placeholder.stock
                }));
              }
            }
            else
            {
              _self.cart.deleteBasketFirst = false;
              CeresNotification.success(ceresTranslate("CartSave::Template.notesArtikelhinzugefuegt")).closeAfter(3000);
            }
            if(i === response.length-1)
            {
              vueApp.$store.commit("setBasketItems", response[i].basketItems);
              vueApp.$store.commit("setBasket", response[i].basket);
            }
          }
          if(_self.deleteItemsFromList === 'true')
          {
            let moddedCart = _self.deleteAfterBasket(data.items,cart);
            _self.$store.dispatch('updateCart',moddedCart)
          }
        },
        error: function (jqXHR, textStatus, errorThrown)
        {
          _self.cart.deleteBasketFirst = false;
          (Object.keys(item).length == 0) ? _self.cart.waiting = false : item.cartloading = false;
          console.log('error',jqXHR,textStatus,errorThrown)
        }
      });
    },
    deleteAfterBasket(items,cart)
    {
      for( let i = 0; i < items.length; i++)
      {
        for(let i2 = 0; i2 < cart.cart_variations.length; i2++)
        {
          if(parseInt(cart.cart_variations[i2].id) === parseInt(items[i].variationId))
          {
            cart.cart_variations.splice(i2,1)
          }
        }
        for(let i3 = 0; i3 < cart.items.length; i3++)
        {
          if(parseInt(cart.items[i3].id) === parseInt(items[i].variationId))
          {
            cart.items.splice(i3,1)
          }
        }
      }
      return cart;
    }

  },
  computed:
  {
    urlWithVariationId()
    {
      return !this.$ceres.config.item.showPleaseSelect || this.$ceres.initialPleaseSelect == 0 || this.forceUrlWithVariationId;
    },
  }
}
</script>

